(function () {
  // Tabla de días laborables según cantidad (dias hasta que el pedido esta listo para entrega)
  var RANGOS_DIAS = [
    { min: 1, max: 2, dias: 3 },
    { min: 3, max: 5, dias: 3 },
    { min: 6, max: 11, dias: 4 },
    { min: 12, max: 23, dias: 4 },
    { min: 24, max: 35, dias: 6 },
    { min: 36, max: 47, dias: 7 },
    { min: 48, max: 59, dias: 8 },
    { min: 60, max: 71, dias: 9 },
    { min: 72, max: 83, dias: 10 },
    { min: 84, max: 99, dias: 11 },
    { min: 100, max: 119, dias: 12 },
    { min: 120, max: 139, dias: 13 },
    { min: 140, max: 159, dias: 14 },
    { min: 160, max: 179, dias: 15 },
    { min: 180, max: 200, dias: 16 }
  ];

  // Feriados nacionales de Ecuador 2026.
  // IMPORTANTE: verificar cada año con la resolución oficial del Ministerio del Trabajo,
  // ya que algunos feriados (ej. 3 de noviembre) pueden trasladarse de fecha.
  var FERIADOS_ECUADOR = [
    '2026-01-01', // Año Nuevo
    '2026-02-16', // Carnaval
    '2026-02-17', // Carnaval
    '2026-04-03', // Viernes Santo
    '2026-05-01', // Día del Trabajo
    '2026-05-24', // Batalla de Pichincha
    '2026-08-10', // Primer Grito de Independencia
    '2026-10-09', // Independencia de Guayaquil
    '2026-11-02', // Día de los Difuntos
    '2026-11-03', // Independencia de Cuenca
    '2026-12-25'  // Navidad
  ];

  var MESES = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
  ];

  var MENSAJE_FUERA_DE_RANGO = 'Consulta tiempos de entrega';
  var DIAS_MARGEN_SEGUNDA_FECHA = 2;

  // Devuelve el numero de dias laborables para la cantidad, o null si la
  // cantidad esta fuera de la tabla (menor a 1 o mayor a 200).
  function obtenerDiasLaborables(cantidad) {
    var qty = parseInt(cantidad, 10);
    if (isNaN(qty) || qty < 1 || qty > 200) {
      return null;
    }
    for (var i = 0; i < RANGOS_DIAS.length; i++) {
      var rango = RANGOS_DIAS[i];
      if (qty >= rango.min && qty <= rango.max) {
        return rango.dias;
      }
    }
    return null;
  }

  function formatearFechaISO(fecha) {
    var y = fecha.getFullYear();
    var m = String(fecha.getMonth() + 1).padStart(2, '0');
    var d = String(fecha.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }

  function esFeriadoOFinDeSemana(fecha) {
    var dia = fecha.getDay();
    if (dia === 0 || dia === 6) return true;
    return FERIADOS_ECUADOR.indexOf(formatearFechaISO(fecha)) !== -1;
  }

  function sumarDiasLaborables(fechaInicio, diasHabiles) {
    var fecha = new Date(fechaInicio.getTime());
    var sumados = 0;
    while (sumados < diasHabiles) {
      fecha.setDate(fecha.getDate() + 1);
      if (!esFeriadoOFinDeSemana(fecha)) {
        sumados++;
      }
    }
    return fecha;
  }

  function sumarDiasCalendario(fechaInicio, dias) {
    var fecha = new Date(fechaInicio.getTime());
    fecha.setDate(fecha.getDate() + dias);
    return fecha;
  }

  function formatearFechaLegible(fecha) {
    return fecha.getDate() + ' de ' + MESES[fecha.getMonth()];
  }

  function actualizarBloque(bloque) {
    var sectionId = bloque.getAttribute('data-section-id');
    var input = document.getElementById('Quantity-' + sectionId);
    var destino = bloque.querySelector('[data-tiempo-entrega-fecha]');
    if (!input || !destino) return;

    var dias = obtenerDiasLaborables(input.value);

    if (dias === null) {
      destino.textContent = MENSAJE_FUERA_DE_RANGO;
      return;
    }

    var fechaInicio = sumarDiasLaborables(new Date(), dias);
    var fechaFin = sumarDiasCalendario(fechaInicio, DIAS_MARGEN_SEGUNDA_FECHA);

    destino.textContent = formatearFechaLegible(fechaInicio) + ' - ' + formatearFechaLegible(fechaFin);
  }

  function iniciar() {
    var bloques = document.querySelectorAll('[data-tiempo-entrega]');
    bloques.forEach(function (bloque) {
      var sectionId = bloque.getAttribute('data-section-id');
      var input = document.getElementById('Quantity-' + sectionId);
      if (!input) return;

      actualizarBloque(bloque);

      input.addEventListener('change', function () {
        actualizarBloque(bloque);
      });
      input.addEventListener('input', function () {
        actualizarBloque(bloque);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
